import { __decorate, __metadata } from "tslib";
import { Component } from '@angular/core';
var FooterInfoComponent = /** @class */ (function () {
    function FooterInfoComponent() {
    }
    FooterInfoComponent = __decorate([
        Component({
            selector: 'footerInfo',
            templateUrl: 'app/components/footer-info/footer-info.html'
        }),
        __metadata("design:paramtypes", [])
    ], FooterInfoComponent);
    return FooterInfoComponent;
}());
export { FooterInfoComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9vdGVyLWluZm8uY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vd29ya3BsYWNlTGl2aW5nU2VydmljZXMvc3JjL2FwcC9jb21wb25lbnRzL2Zvb3Rlci1pbmZvL2Zvb3Rlci1pbmZvLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFDLFNBQVMsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQU14QztJQUVFO0lBQXNCLENBQUM7SUFGWixtQkFBbUI7UUFKL0IsU0FBUyxDQUFDO1lBQ1QsUUFBUSxFQUFFLFlBQVk7WUFDdEIsV0FBVyxFQUFFLDZDQUE2QztTQUMzRCxDQUFDOztPQUNXLG1CQUFtQixDQUcvQjtJQUFELDBCQUFDO0NBQUEsQUFIRCxJQUdDO1NBSFksbUJBQW1CIn0=